
// ################  AUTHEN ################
export const SET_PROFILE = "SET_PROFILE"
export const CLEAR_PROFILE = "CLEAR_PROFILE"

// ################ FOCUS ##################
export const SET_FOCUS_TEXTFIELD_NAME = 'SET_FOCUS_TEXTFIELD_NAME'
export const SET_DEFAULT = 'SET_DEFAULT'